import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { X, Check, Copy, MessageCircle, Send, Mail } from 'lucide-react';
import './ComponentTaskHoy.css';

// slice 02.1 · paso b — presentacional, extraído verbatim de `ComponentTaskHoy.jsx` (era un
// subcomponente a nivel de módulo que recibía `translate` como prop; ahora resuelve i18n solo).
export const ShareTaskModal = ({ task, onClose }) => {
    const { t: translate } = useTranslation('tasks');
    const [copied, setCopied] = useState(false);
    const link = `${window.location.origin}/t/${task.id}`;
    const message = translate('modal.shareMessage', { title: task.title || translate('common.untitled') });

    useEffect(() => {
        const onKeyDown = (e) => { if (e.key === 'Escape') onClose(); };
        document.addEventListener('keydown', onKeyDown);
        return () => document.removeEventListener('keydown', onKeyDown);
    }, [onClose]);

    const handleCopy = async () => {
        await navigator.clipboard.writeText(link);
        setCopied(true);
        setTimeout(() => setCopied(false), 1500);
    };

    const shareLinks = [
        { key: 'whatsapp', label: translate('modal.shareWhatsapp'), Icon: MessageCircle, href: `https://wa.me/?text=${encodeURIComponent(`${message} ${link}`)}` },
        { key: 'telegram', label: translate('modal.shareTelegram'), Icon: Send, href: `https://t.me/share/url?url=${encodeURIComponent(link)}&text=${encodeURIComponent(message)}` },
        { key: 'email', label: translate('modal.shareEmail'), Icon: Mail, href: `mailto:?subject=${encodeURIComponent(translate('modal.shareEmailSubject'))}&body=${encodeURIComponent(`${message} ${link}`)}` },
    ];

    return (
        <div className="share-task-modal-overlay" onClick={onClose}>
            <div className="share-task-modal" onClick={(e) => e.stopPropagation()}>
                <div className="share-task-modal-header">
                    <h3>{translate('modal.shareTitle')}</h3>
                    <button type="button" onClick={onClose} title={translate('modal.close')} aria-label={translate('modal.close')}>
                        <X size={16} />
                    </button>
                </div>

                <div className="share-task-modal-link-row">
                    <input type="text" readOnly value={link} aria-label={translate('modal.shareLinkAriaLabel')} onFocus={(e) => e.target.select()} />
                    <button type="button" className={copied ? 'copied' : ''} onClick={handleCopy}>
                        {copied ? <Check size={14} /> : <Copy size={14} />}
                        {copied ? translate('modal.shareCopied') : translate('modal.shareCopy')}
                    </button>
                </div>

                <div className="share-task-modal-targets">
                    {shareLinks.map((item) => (
                        <a key={item.key} href={item.href} target="_blank" rel="noopener noreferrer">
                            <item.Icon size={18} />
                            <span>{item.label}</span>
                        </a>
                    ))}
                </div>

                <div className="share-task-modal-public-section" style={{ marginTop: '20px', paddingTop: '20px', borderTop: '1px solid var(--border-color, #333)' }}>
                    <div style={{ marginBottom: '12px' }}>
                        <h4 style={{ margin: '0 0 4px 0', fontSize: '14px', color: 'var(--color-accent, #95e248)' }}>Enlace Público (Lectura)</h4>
                        <p style={{ margin: 0, fontSize: '12px', color: 'var(--text-secondary, #a0a0a0)' }}>Cualquier persona con este enlace podrá ver los detalles de la tarea sin iniciar sesión.</p>
                    </div>
                    <div className="share-task-modal-link-row">
                        <input type="text" readOnly value={link} aria-label="Enlace Público" onFocus={(e) => e.target.select()} />
                        <button type="button" className={copied ? 'copied' : ''} onClick={handleCopy}>
                            {copied ? <Check size={14} /> : <Copy size={14} />}
                            {copied ? translate('modal.shareCopied') : translate('modal.shareCopy')}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ShareTaskModal;
